<template>
    <div class="component-login login-box">

            <div class="panel">

                <form v-on:submit.prevent="formSubmit" enctype="multipart/form-data">
                    <div class="form-fields-wrapper">
                        <div class="form-field-wrapper form-field-username">
                            <label>Username
                                <input type="text" placeholder="username" v-model="login.username">
                            </label>
                        </div>
                        <div class="form-field-wrapper form-field-password">
                            <label>Password
                                <input type="password" placeholder="password" v-model="login.password">
                            </label>
                        </div>

                        <div class="form-message-catch text-center">
                            <slot/>
                        </div>

                        <div class="form-field-wrapper form-field-submit">

                            <input class="submit button" type="submit" value="Login">

                        </div>

                        <div class="login-footer-area">

                          <!--<hr>
                          <p>Lost your password? <a href="#">Click here to reset</a></p>-->

                        </div>

                    </div>
                </form>
            </div>
        </div>
</template>
<script type="text/babel">
    export default{
        name: "Login",
        data () {
            return {
                login: {
                    username: null,
                    password: null,
                },
            }
        },
        methods: {
            formSubmit: function () {
                this.$emit('login', this.login)
            }
        },
    }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Login.vue?52cce97b